/* Cart presentation rules, not server-side checkout validation. */
(() => {
  if (window.__sabPeregrinoCart) return;
  window.__sabPeregrinoCart = true;
  const variantId = 57174148514170;
  const productId = 16167951434106;
  const root = window.Shopify?.routes?.root || '/';
  let busy = false;
  let auditTimer;

  async function request(path, body) {
    const response = await fetch(root + path, {
      method: body ? 'POST' : 'GET',
      headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
      ...(body ? { body: JSON.stringify(body) } : { cache: 'no-store' })
    });
    if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
    return response.json();
  }

  function state(cart) {
    return {
      addon: cart.items.filter(item => item.variant_id === variantId),
      main: cart.items.some(item => item.product_id !== productId && !item.gift_card && item.final_line_price > 0),
      peregrino: cart.items.some(item => item.product_id === productId && item.variant_id !== variantId)
    };
  }

  async function refresh(cart) {
    const component = document.querySelector('#cart-drawer cart-items-component') || document.querySelector('cart-items-component');
    if (cart.items.length && typeof component?.updateQuantity === 'function') {
      await component.updateQuantity({ line: 1, quantity: cart.items[0].quantity, action: 'change' });
    } else {
      window.location.reload();
    }
  }

  // Line keys preserve separate selling plans/properties and avoid unstable indexes.
  async function normalize(cart) {
    const current = state(cart);
    if (!current.addon.length) return { cart, changed: false };
    let remaining = current.main && !current.peregrino ? 1 : 0;
    let changed = false;
    for (const item of current.addon) {
      const quantity = Math.min(item.quantity, remaining);
      remaining -= quantity;
      if (quantity !== item.quantity) {
        cart = await request('cart/change.js', { id: item.key, quantity });
        changed = true;
      }
    }
    return { cart, changed };
  }

  async function audit() {
    if (busy) return;
    busy = true;
    try {
      const result = await normalize(await request('cart.js'));
      if (result.changed) await refresh(result.cart);
    } catch (error) {
      console.warn('Peregrino cart check failed', error);
    } finally {
      busy = false;
    }
  }

  document.addEventListener('click', async event => {
    const button = event.target.closest?.('[data-pgr-add]');
    if (!button || button.disabled || busy) return;
    event.preventDefault();
    busy = true;
    const buttons = document.querySelectorAll('[data-pgr-add]');
    buttons.forEach(item => { item.disabled = true; });
    const errorNode = button.closest('[data-pgr-offer]')?.querySelector('[data-pgr-error]');
    if (errorNode) errorNode.hidden = true;
    try {
      let cart = await request('cart.js');
      const current = state(cart);
      if (!current.main || current.peregrino || current.addon.length) {
        await refresh(cart);
        return;
      }
      // Recheck the published price before adding; never promise a stale price.
      const product = await request('products/pack-peregrino.js');
      const variant = product.variants.find(item => item.id === variantId);
      if (!variant?.available || variant.price !== 399 || cart.currency !== 'EUR') throw new Error('Offer unavailable');
      await request('cart/add.js', { items: [{ id: variantId, quantity: 1 }] });
      cart = await request('cart.js');
      const result = await normalize(cart);
      await refresh(result.cart);
    } catch (error) {
      buttons.forEach(item => { item.disabled = false; });
      if (errorNode) {
        errorNode.textContent = button.dataset.error;
        errorNode.hidden = false;
      }
    } finally {
      busy = false;
    }
  });

  function scheduleAudit() {
    clearTimeout(auditTimer);
    auditTimer = setTimeout(audit, 200);
  }
  document.addEventListener('shopify:cart:lines-update', event => {
    // Horizon emits this before the mutation; wait for its completion.
    const pending = event.detail?.promise;
    if (pending?.then) pending.then(scheduleAudit, scheduleAudit);
    else scheduleAudit();
  });
  window.addEventListener('pageshow', scheduleAudit);
})();
